import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import TextEditable from 'common/components/TouchpointEditor/TextEditable';

import { SessionButton } from './AttendeeSessionsList.styles';
import { descendantsPropTypes } from './defaults';

export default function WatchSessionButton({
    colors,
    activeFonts,
    styles,
    meta,
    setContent,
    disableContentEditing,
    to,
    isWatchButtonEnabled,
}) {
    // Needed in order to not lose query params like guest-access-hash.
    const { search } = useLocation();
    const isDisabled = !isWatchButtonEnabled;

    return (
        <SessionButton
            $fontFamily={activeFonts[styles.fontFamily]}
            $fontColor={colors[styles.fontColor]}
            $fontColorHover={colors[styles.fontColorHover]}
            $fontSize={styles.fontSize}
            $backgroundColor={colors[styles.backgroundColor]}
            $backgroundColorHover={colors[styles.backgroundColorHover]}
            $borderColor={colors[styles.borderColor]}
            $borderColorHover={colors[styles.borderColorHover]}
            $borderWidth={styles.borderWidth}
            $borderRadius={styles.borderRadius}
            to={!isDisabled ? `${to}${search}` : search}
            onClick={(e) => {
                // We need to prevent the default action of the link if editing as we want to prevent the user from
                // leaving the page. We also need to prevent the default action so that we can use textEditable.
                if (!disableContentEditing) {
                    e.preventDefault();
                }
            }}
            replace={isWatchButtonEnabled}
            disabled={isDisabled}
            tabIndex={isDisabled && '-1'}
            data-qa="session_watch_button"
        >
            <TextEditable setContent={setContent} disabled={disableContentEditing}>
                {meta.content}
            </TextEditable>
        </SessionButton>
    );
}

WatchSessionButton.propTypes = {
    isWatchButtonEnabled: PropTypes.bool.isRequired,
    colors: PropTypes.array.isRequired,
    activeFonts: PropTypes.array.isRequired,
    styles: PropTypes.shape(descendantsPropTypes.sessionButton.styles).isRequired,
    meta: PropTypes.shape(descendantsPropTypes.sessionButton.meta).isRequired,
    setContent: PropTypes.func.isRequired,
    disableContentEditing: PropTypes.bool,
    to: PropTypes.string.isRequired,
};

WatchSessionButton.defaultProps = {
    disableContentEditing: false,
};
